
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-way-billing",
      function () {
        return require("private-next-pages/e-way-billing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e-way-billing"])
      });
    }
  